import { autoIncerateOrder } from "@/services/GlobalServices";
import ShowRevisionServices from "@/services/ShowRevisionServices";
import DashboardConstants from "@/store/constants/dashboardRecords";
import DashboardServices from "@/services/DashboardServices";
import { callLLMApiWithCallback } from "@/api/ChatApi";
import QualificationApi from "@/api/QualificationApi";
import { getSiteContractCompanies } from "@/api/SiteApi";
import SafetyInstructionChat from "@/components/shared/SafetyInstructionChat";

export default {
  name: "WorkContentModal",
  components: { SafetyInstructionChat },
  props: ["isCreate"],
  data() {
    return {
      contractCompanies: [],
      selectedContractCompanyId: null,
      qualificationOptions: [],
      qualificationSearchTimeout: null,
      usedMachineAttr1: "",
      usedMachineAttr2: "",
      usedMachineAttrCount: "",
      meetingTopic: "",
      meetings: [
        {
          meetingTopic: "",
          meetingContent: "",
        },
      ],
      aiSuggestion: "",
      isLoadingAiSuggestion: false,
      safetyInstructionsFields: [
        { label: "安全", value: "safety" },
        { label: "品質", value: "quanlity" },
        { label: "環境", value: "enviroment" },
      ],
      meetingOptions: [
        { label: "〇", value: false },
        // { label: "◎", value: true },
      ],
      confirmOptions: [
        { label: "〇", value: false },
        { label: "✕", value: true },
      ],
      lastFetchedSiteId: null,
      isFetchingCompanies: false,
    };
  },
  computed: {
    tempworkRecord: {
      get: function () {
        return this.$store.getters[
          DashboardConstants.GETTERS.getTempWorkRecord
        ];
      },
      set: function (tempWorkRecord) {
        this.$store.commit(DashboardConstants.COMMIT.setTempWorkRecord, {
          tempWorkRecord: tempWorkRecord,
        });
      },
    },
    getStatusEditable() {
      return this.$store.getters[DashboardConstants.GETTERS.getStatusEditable];
    },
    getQualificatedResponsibleFreezaOrder() {
      return this.$store.getters[DashboardConstants.GETTERS.getOrderIdFreeze]
        .workRecordsQualifiedResponsible;
    },
    getEquipmentFreezaOrder() {
      return this.$store.getters[DashboardConstants.GETTERS.getOrderIdFreeze]
        .workRecordsEquipments;
    },
    getSafetyInstructionFreezaOrder() {
      return this.$store.getters[DashboardConstants.GETTERS.getOrderIdFreeze]
        .workRecordsSafetyInstructions;
    },
    storeSiteId() {
      return this.$store.getters[DashboardConstants.GETTERS.getDiaryRevisions]?.siteId || null;
    },
    routeSiteId() {
      return this.$route?.query?.siteId || null;
    },
    effectiveSiteId() {
      return this.storeSiteId || this.routeSiteId;
    },
  },
  watch: {
    tempworkRecord: {
      async handler(newVal) {
        if (newVal && newVal.contractCompanyId !== this.selectedContractCompanyId) {
          this.selectedContractCompanyId = newVal.contractCompanyId;
        }

        if (newVal && newVal.qualificatedResponsible) {
          // 非同期処理を順次実行するためにfor...ofを使用
          for (let index = 0; index < newVal.qualificatedResponsible.length; index++) {
            const quanlificate = newVal.qualificatedResponsible[index];
            if (quanlificate.qualificationId && !quanlificate.qualificationData) {
              await this.loadQualificationData(quanlificate.qualificationId, index);
            }
          }
        }
      },
      deep: true,
      immediate: true
    }
  },
  methods: {
    async onModalShown() {
      await this.ensureContractCompanies();
    },
    async ensureContractCompanies() {
      const siteId = this.effectiveSiteId;
      
      if (!siteId || siteId === this.lastFetchedSiteId || this.isFetchingCompanies) {
        return;
      }

      this.isFetchingCompanies = true;
      try {
        await this.fetchContractCompanies(siteId);
        this.lastFetchedSiteId = siteId;
      } finally {
        this.isFetchingCompanies = false;
      }
    },
    async fetchContractCompanies(siteId) {
      try {
        if (!siteId) {
          console.error('siteIdが取得できませんでした');
          return;
        }

        // 現場に紐づく契約企業を取得（APIレスポンスにcontractCompanyNameが含まれる）
        const siteContractCompaniesResponse = await getSiteContractCompanies(siteId);
        const siteContractCompanies = siteContractCompaniesResponse.data.siteContractCompanies || [];

        // APIレスポンスから直接契約企業情報を取得（contractCompanyIdとcontractCompanyNameが含まれる）
        this.contractCompanies = siteContractCompanies.map(scc => ({
          id: scc.contractCompanyId,
          name: scc.contractCompanyName || `会社ID: ${scc.contractCompanyId}`
        }));
      } catch (error) {
        console.error('契約企業の取得に失敗しました:', error);
        this.$bvToast.toast('契約企業の取得に失敗しました。', {
          title: 'エラー',
          variant: 'danger',
          solid: true
        });
      }
    },
    onContractCompanySelect(contractCompanyId) {
      this.selectedContractCompanyId = contractCompanyId;
      if (contractCompanyId) {
        const selectedCompany = this.contractCompanies.find(c => c.id === contractCompanyId);
        if (selectedCompany && selectedCompany.name) {
          this.setDataInputWorkModal('primaryConstractor', selectedCompany.name);
          this.setDataInputWorkModal('contractCompanyId', contractCompanyId);
        }
      } else {
        this.setDataInputWorkModal('contractCompanyId', null);
      }
    },
    addUsedQualificatedResponsible() {
      const styleTemp = ShowRevisionServices.createTemplate(
        "workRecordsQualifiedResponsible"
      );
      const recordTemp = ShowRevisionServices.createTemplatePreviousValue(
        "workRecordsQualifiedResponsible"
      );
      let recordOrder = 1;
      if (this.getQualificatedResponsibleFreezaOrder) {
        const quanlifyOrders =
          this.getQualificatedResponsibleFreezaOrder[this.tempworkRecord.order];
        recordOrder = autoIncerateOrder(
          quanlifyOrders,
          this.tempworkRecord.qualificatedResponsible
        );
      }
      const record = {
        order: recordOrder,
        qualification: "",
        name: "",
        qualificationId: null,
        qualificationData: null,
        style: styleTemp,
        previousItem: recordTemp,
      };
      this.$store.commit(
        DashboardConstants.COMMIT.addQualificatedResponsibleField,
        record
      );
    },
    removeQuanlificatedResponsible(index) {
      this.$store.commit(
        DashboardConstants.COMMIT.removeQuanlificatedResponsible,
        index
      );
    },
    addUsedEquipmentField() {
      const styleEquipment = ShowRevisionServices.createTemplate(
        "workRecordsEquipments"
      );
      const recordEquipment = ShowRevisionServices.createTemplatePreviousValue(
        "workRecordsEquipments"
      );
      let recordOrder = 1;
      if (this.getEquipmentFreezaOrder != undefined) {
        const oldEquipmentOrder =
          this.getEquipmentFreezaOrder[this.tempworkRecord.order];
        recordOrder = autoIncerateOrder(
          oldEquipmentOrder,
          this.tempworkRecord.equipments
        );
      }
      const usedEquiment = {
        order: recordOrder,
        type: "",
        subType: "",
        number: "",
        unit: this.$t("workContent.equipments.unit"),
        style: styleEquipment,
        previousItem: recordEquipment,
      };
      this.$store.commit(
        DashboardConstants.COMMIT.addUsedEquipmentField,
        usedEquiment
      );
    },
    removeUsedEquipmentField(index) {
      this.$store.commit(
        DashboardConstants.COMMIT.removeUsedEquipmentField,
        index
      );
    },
    addSafetyInstructions() {
      const styleSafetyInstruction = ShowRevisionServices.createTemplate(
        "workRecordsSafetyInstructions"
      );
      const recordSafetyInstruction =
        ShowRevisionServices.createTemplatePreviousValue(
          "workRecordsSafetyInstructions"
        );
      let recordOrder = 1;
      if (this.getSafetyInstructionFreezaOrder != undefined) {
        const oldSafetyInstruction =
          this.getSafetyInstructionFreezaOrder[this.tempworkRecord.order];
        recordOrder = autoIncerateOrder(
          oldSafetyInstruction,
          this.tempworkRecord.safetyInstructions
        );
      }
      const safetyInstuction = {
        order: recordOrder,
        type: "",
        instruction: "",
        confirmed: null,
        style: styleSafetyInstruction,
        previousItem: recordSafetyInstruction,
      };
      this.$store.commit(
        DashboardConstants.COMMIT.addSafetyInstructions,
        safetyInstuction
      );
    },
    removeSafetyInstructions(index) {
      this.$store.commit(
        DashboardConstants.COMMIT.removeSafetyInstructions,
        index
      );
    },
    // AI安全指示アシスタントで選択したおすすめ指示を新しい行として反映する
    applyRecommendedInstruction(payload) {
      this.addSafetyInstructions();
      const index = this.tempworkRecord.safetyInstructions.length - 1;
      if (payload.type) {
        this.setDataInputWorkModal("safetyInstructions.type", payload.type, index);
      }
      this.setDataInputWorkModal(
        "safetyInstructions.instruction",
        payload.instruction,
        index
      );
    },
    setDataInputWorkModal(attr, value, index = -1) {
      this.$store.commit(DashboardConstants.COMMIT.setDataInputWorkModal, {
        attr: attr,
        value: value,
        index: index,
      });
    },
    registerInputWork() {
      this.$store.commit(
        DashboardConstants.COMMIT.setWorkContentModalRecord,
        this.tempworkRecord
      );
      this.$store.commit(DashboardConstants.COMMIT.recalculateRevision);
      this.$bvModal.hide("work-content-modal");
      this.tempworkRecord = {
        order: undefined,
        primaryConstractor: "",
        subContractor: "",
        workType: "",
        workDescription: "",
        sign: "",
        contractCompanyId: null,
        qualificatedResponsible: [
          {
            order: 0,
            qualification: "",
            name: "",
            qualificationId: null,
            qualificationData: null,
          },
        ],
        numberOfPeople: {
          budget: "",
          actual: "",
        },
        equipments: [
          {
            order: 0,
            type: "",
            subType: "",
            number: "",
            unit: this.$t("workContent.equipments.unit"),
          },
        ],
        safetyInstructions: [
          {
            order: 0,
            type: "",
            instruction: "",
            confirmed: null,
          },
        ],
        useOfFire: false,
      };
      this.selectedContractCompanyId = null;
    },
    updateInputWork() {
      this.$store.commit(
        DashboardConstants.COMMIT.updateWorkContentModalRecord,
        this.tempworkRecord
      );
      this.$store.commit(DashboardConstants.COMMIT.recalculateRevision);
      this.$bvModal.hide("work-content-modal");
      this.tempworkRecord = {
        order: undefined,
        primaryConstractor: "",
        subContractor: "",
        workType: "",
        workDescription: "",
        sign: "",
        contractCompanyId: null,
        qualificatedResponsible: [
          {
            order: 0,
            qualification: "",
            name: "",
            qualificationId: null,
            qualificationData: null,
          },
        ],
        numberOfPeople: {
          budget: 0,
          actual: 0,
        },
        equipments: [
          {
            order: 0,
            type: "",
            subType: "",
            number: "",
            unit: this.$t("workContent.equipments.unit"),
          },
        ],
        safetyInstructions: [
          {
            order: 0,
            type: "",
            instruction: "",
            confirmed: null,
          },
        ],
        useOfFire: false,
      };
      this.selectedContractCompanyId = null;
    },
    cancelInputWork() {
      this.$bvModal.hide("work-content-modal");
    },
    requestAiSuggestion() {
      // workTypeとworkDescriptionの値を取得
      const workType = this.tempworkRecord.workType;
      const workDescription = this.tempworkRecord.workDescription;

      // 値が空の場合は処理を中止
      if (!workType || !workDescription) {
        this.$bvToast.toast("工種と作業内容を入力してください。", {
          title: "入力エラー",
          variant: "danger",
          solid: true,
        });
        return;
      }

      // 質問文を生成
      const question = `${workType} の工種で、${workDescription} の場合に気をつけるべき安全指示事項を箇条書きで教えてください。`;

      // ローディング状態を設定
      this.isLoadingAiSuggestion = true;
      this.aiSuggestion = "回答を生成中...";

      // 最初のチャンクを受信したかどうかのフラグ
      let isFirstChunk = true;

      // LLM APIを呼び出し
      callLLMApiWithCallback(
        question,
        // チャンクごとのコールバック
        (chunk) => {
          try {
            // 文字列の場合はJSONとしてパース
            const data = typeof chunk === "string" ? JSON.parse(chunk) : chunk;

            // chatMetadataを含むチャンクは無視（最初のチャンク）
            if (data.result && data.result.chatMetadata) {
              // 最初のチャンクが来たら、「回答を生成中...」をクリア
              if (isFirstChunk) {
                this.aiSuggestion = "";
                isFirstChunk = false;
              }
              return;
            }

            // 最初のチャンクが来たら、「回答を生成中...」をクリア
            if (isFirstChunk) {
              this.aiSuggestion = "";
              isFirstChunk = false;
            }

            // result.tokenがある場合はそれを追加
            if (data.result && data.result.token) {
              this.aiSuggestion += data.result.token;
            } else if (data.content) {
              // 従来の形式の場合
              this.aiSuggestion += data.content;
            } else if (typeof data === "string") {
              // 単純な文字列の場合
              this.aiSuggestion += data;
            }
          } catch (e) {
            // JSONパースに失敗した場合は文字列としてそのまま追加
            console.warn("Failed to parse chunk as JSON:", e);
            if (typeof chunk === "string") {
              // 最初のチャンクが来たら、「回答を生成中...」をクリア
              if (isFirstChunk) {
                this.aiSuggestion = "";
                isFirstChunk = false;
              }
              this.aiSuggestion += chunk;
            }
          }
        },
        // 完了時のコールバック
        (fullText) => {
          console.debug("LLM API full response:", fullText);
          this.isLoadingAiSuggestion = false;
        },
        // エラー時のコールバック
        (error) => {
          console.error("LLM API error:", error);
          this.aiSuggestion = "エラーが発生しました。もう一度お試しください。";
          this.isLoadingAiSuggestion = false;
          this.$bvToast.toast("AIからの回答取得中にエラーが発生しました。", {
            title: "エラー",
            variant: "danger",
            solid: true,
          });
        }
      );
    },
    showSignModal() {
      this.$store.commit("dashboardRecords/setSignature", {
        order: this.tempworkRecord.order,
        dataImage: this.tempworkRecord.presignedUrl,
        signFor: "SignWorkRecord",
      });
      this.$bvModal.show("signature-modal");
    },
    isImageBaseURL(sign) {
      return DashboardServices.isImageBaseURL(sign);
    },
    async onQualificationSearch(search, loading) {
      if (search.length < 1) {
        this.qualificationOptions = [];
        return;
      }

      if (this.qualificationSearchTimeout) {
        clearTimeout(this.qualificationSearchTimeout);
      }

      this.qualificationSearchTimeout = setTimeout(async () => {
        try {
          if (loading) loading(true);
          const response = await QualificationApi.searchQualifications({
            name: search,
            limit: 50
          });
          
          if (response.data && response.data.qualifications) {
            this.qualificationOptions = response.data.qualifications.map(q => ({
              label: `(${q.shortName})[${q.name}]`,
              value: q.id,
              qualification: q
            }));
          }
        } catch (error) {
          console.error('資格証の検索に失敗しました:', error);
          this.$bvToast.toast('資格証の検索に失敗しました。', {
            title: 'エラー',
            variant: 'danger',
            solid: true
          });
        } finally {
          if (loading) loading(false);
        }
      }, 300);
    },
    onQualificationSelect(selectedOption, index) {
      // 選択解除時（nullまたはundefined）
      if (!selectedOption) {
        const clearedQualification = {
          ...this.tempworkRecord.qualificatedResponsible[index],
          qualification: '',
          qualificationId: null,
          qualificationData: null
        };
        this.$store.commit(DashboardConstants.COMMIT.setDataInputWorkModal, {
          attr: 'qualificatedResponsible',
          value: this.tempworkRecord.qualificatedResponsible.map((item, idx) =>
            idx === index ? clearedQualification : item
          ),
          index: -1
        });
        return;
      }

      // 手入力の場合（文字列が直接渡される）
      if (typeof selectedOption === 'string') {
        const manualQualification = {
          ...this.tempworkRecord.qualificatedResponsible[index],
          qualification: selectedOption,
          qualificationId: null,
          qualificationData: null
        };
        this.$store.commit(DashboardConstants.COMMIT.setDataInputWorkModal, {
          attr: 'qualificatedResponsible',
          value: this.tempworkRecord.qualificatedResponsible.map((item, idx) =>
            idx === index ? manualQualification : item
          ),
          index: -1
        });
        return;
      }

      // 検索から選択した場合
      if (selectedOption && selectedOption.qualification) {
        const qualification = selectedOption.qualification;
        const updatedQualification = {
          ...this.tempworkRecord.qualificatedResponsible[index],
          qualification: qualification.shortName,
          qualificationId: qualification.id,
          qualificationData: qualification
        };
        this.$store.commit(DashboardConstants.COMMIT.setDataInputWorkModal, {
          attr: 'qualificatedResponsible',
          value: this.tempworkRecord.qualificatedResponsible.map((item, idx) =>
            idx === index ? updatedQualification : item
          ),
          index: -1
        });
      }
    },
    getQualificationDisplay(quanlificate) {
      // qualificationData が存在する場合は完全な情報で表示
      if (quanlificate.qualificationId && quanlificate.qualificationData) {
        return {
          label: `(${quanlificate.qualificationData.shortName})[${quanlificate.qualificationData.name}]`,
          value: quanlificate.qualificationId,
          qualification: quanlificate.qualificationData
        };
      }
      // qualificationData がないが qualificationId がある場合は、略称のみ表示（データロード中）
      else if (quanlificate.qualificationId && quanlificate.qualification) {
        return {
          label: quanlificate.qualification,
          value: quanlificate.qualificationId,
          qualification: null
        };
      }
      // 手動入力された略称のみの場合（後方互換性）
      else if (quanlificate.qualification) {
        return {
          label: quanlificate.qualification,
          value: null,
          qualification: null
        };
      }
      return null;
    },
    async loadQualificationData(qualificationId, index) {
      // NOTE: 本来はIDで直接取得するAPI（GET /user/qualifications/{id}）を使用すべきですが、
      // 現在はemployee用のgetエンドポイントが存在しないため、検索APIで全件取得して該当するものを探しています。
      // 将来的にはバックエンドにemployee用のgetエンドポイントを追加することを推奨します。
      try {
        const response = await QualificationApi.searchQualifications({
          limit: 1000 // より多くの資格証をカバーするために増やしています
        });

        if (response.data && response.data.qualifications) {
          const qualification = response.data.qualifications.find(q => q.id === qualificationId);
          if (qualification) {
            // qualificatedResponsible配列全体を更新して確実に反映させる
            const updatedQualificatedResponsible = this.tempworkRecord.qualificatedResponsible.map((item, idx) => {
              if (idx === index) {
                return {
                  ...item,
                  qualificationData: qualification
                };
              }
              return item;
            });

            this.$store.commit(DashboardConstants.COMMIT.setDataInputWorkModal, {
              attr: 'qualificatedResponsible',
              value: updatedQualificatedResponsible,
              index: -1
            });
          }
        }
      } catch (error) {
        console.error('資格証の取得に失敗しました:', error);
      }
    },
  },
  mounted() {
    this.$watch(() => this.effectiveSiteId, (newSiteId) => {
      if (newSiteId && newSiteId !== this.lastFetchedSiteId) {
        this.ensureContractCompanies();
      }
    }, { immediate: true });
  }
};
